import { atom } from 'jotai'

export const forceShowTrackingConsentBannerAtom = atom<boolean>(false)
